<template>
  <div :class="`gallery-container ${disableShadow ? 'gray-fill' : ''}`">
    <Hooper
      class="hooper-gal"
      :id="idString"
      :ref="idString"
      :itemsToShow="1"
      :itemsToSlide="1"
      :mouseDrag="false"
      :touchDrag="true"
      :wheelControl="false"
      @slide="hooperSlide"
    >
      <Slide v-for="(image, index) in data" :key="idString + index">
        <img
          :class="`slide-image ${isModal ? 'isModal' : ''}`"
          :style="`${
            imageDimensions && imageDimensions.height
              ? `height: ${imageDimensions.height};`
              : ''
          } ${
            imageDimensions && imageDimensions.width
              ? `width: ${imageDimensions.width};`
              : ''
          }`"
          :src="image"
        />
      </Slide>
      <HooperPagination
        v-if="!data || data.length > 1"
        slot="hooper-addons"
      ></HooperPagination>
    </Hooper>
    <button
      v-if="!data || data.length > 1"
      id="prevArrow"
      class="navArrow"
      @click="imageIndexSelected(currentImageIndex - 1)"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12 .686l2.828 2.829L6.342 12l8.486 8.485L12 23.314.686 12 12 .686z" fill="#BCBCBC" fill-rule="evenodd"/></svg>
    </button>

    <button
      v-if="!data || data.length > 1"
      id="nextArrow"
      class="navArrow"
      @click="imageIndexSelected(currentImageIndex + 1)"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12 .686l2.828 2.829L6.342 12l8.486 8.485L12 23.314.686 12 12 .686z" fill="#BCBCBC" fill-rule="evenodd"/></svg>
    </button>
  </div>
</template>


<script>
import { Hooper, Slide, Pagination as HooperPagination } from "hooper";
import "hooper/dist/hooper.css";
export default {
  name: "ImageGallery",
  components: {
    Hooper,
    Slide,
    HooperPagination,
  },
  data() {
    return {
      currentImageIndex: 0,
      isVertical: false,
    };
  },
  props: {
    idString: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    disableShadow: {
      type: Boolean,
      required: false,
    },
    imageDimensions: {
      type: Object,
      required: false,
    },
    isModal: {
      type: Boolean,
      required: false,
    },
  },
  watch: {
    data: function (newVal, oldVal) {
      this.currentImageIndex = 0;
    },
  },
  methods: {
    imageIndexSelected(newIndex) {
      let ele = this.$refs[this.idString];
      const indexMax = this.data.length - 1;
      if (newIndex < 0) {
        newIndex = indexMax;
      } else if (newIndex > indexMax) {
        newIndex = 0;
      }
      ele.slideTo(newIndex);
    },
    hooperSlide(props) {
      this.currentImageIndex = props.currentSlide;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.gallery-container {
  width: 100%;
  position: relative;

  .hooper-gal {
    height: auto;
    outline: none;
  }
  .gallery-top {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 99;
    background: transparent;
    max-width: 100%;
    height: 44px;
    @media (max-width: $sm) {
      top: -60px;
      flex-direction: column;
      padding: 10px 0;
      height: auto;
    }
  }
  .gallery-slide {
    position: relative;
    outline: none;
  }
  .slide-image {
    min-width: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    height: auto;
    outline: none;
  }
  .isModal {
    height: calc(80vh - 56px);
  }

  .arrow-opacity {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    width: 50%;
    flex: 1;
  }
  .prev-arrow-opacity {
    align-items: flex-start;
    background-image: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.3) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }
  .next-arrow-opacity {
    align-items: flex-end;
    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(0, 0, 0, 0.3) 100%
    );
  }
  .prev-arrow-transp {
    align-items: flex-start;
  }
  .next-arrow-transp {
    align-items: flex-end;
  }
}

svg,
img {
  height: 24px;
  width: 24px;
}
.navArrow {
  transition: all 0.2s ease-in-out;
  background: transparent;
  border: none;
  margin: 15px;
  position: absolute;
  top: 50%;
  z-index: 5;
  transform: translateY(-100%);

  &:hover {
    path {
      fill: #ce0e2d;
    }
  }
}
path {
  fill: #fff;
}

.gray-fill {
  path {
    fill: rgb(188, 188, 188) !important;
  }
}
#prevArrow {
  left: 0;
  img,
  svg {
    outline: none;
  }
}
#nextArrow {
  right: 0;
  img,
  svg {
    transform: rotate(180deg);
    outline: none;
  }
}
.navArrow:focus {
  outline: none;
}
</style>

<style lang="scss">
.hooper-track {
  .hooper-slide {
    width: 100% !important;
    height: 100%;
    img {
      max-height: 100%;
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }
}
.gray-fill {
  .hooper-indicator {
    background-color: rgb(188, 188, 188);
  }
}
.hooper-pagination {
  padding-bottom: 14px;
  z-index: 99 !important;
  .hooper-indicators {
    .hooper-indicator {
      height: 10px;
      width: 10px;
      border-radius: 50%;
      margin: 0 4px;
      outline: none;
      &:hover {
        cursor: pointer;
        background-color: #ce0e2d;
      }
    }

    .is-active {
      background-color: #ce0e2d;
    }
  }
}
</style>


